import {Fancybox} from "@fancyapps/ui";

import Choices from 'choices.js';
import Swiper, {Navigation, Pagination, Thumbs, EffectFade} from 'swiper';
import events from "./base";

import {parseHTML} from "./Components/Core/common";

require('./base');

if (document.querySelector('.js_open_modal_add_comment')) {
    const comments = async () => await import("./Components/Comments/comment");
    comments().then(t => t.init(events));
}

const js_article_block = document.querySelector('.js_article_block');
if (js_article_block) {
    const js_anchors_block = document.querySelector('.js_anchors');

    if (js_anchors_block) {
        const js_anchors_div = js_anchors_block.querySelector('.js_anchor_div');
        if (js_anchors_div) {
            let titles = js_article_block.querySelectorAll('h2, h3');

            titles.forEach((item, i) => {
                let clone = item.cloneNode( true );
                [...clone.children].forEach(child => clone.removeChild(child))
                clone.id = `anchor-${i}`;
                let anchor = parseHTML(`<a class="baner-category__item fs-16 lh-1_2" 
                                                     href="#anchor-${i}" 
                                                    title="Перейти к ${clone.innerText}"
                                            >
                                    <span class="d-inline-block">${clone.innerText}</span>
                                    <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.89742 30.5V15.834H0.508545L13.6921 0.5V15.834H21.4912L7.89742 30.5Z" fill="#FFDD33"></path>
                                    </svg>
                                </a>`);
                js_anchors_div.append(anchor);
            });


            if (titles.length) {
                js_anchors_block.classList.remove('d-none');
                js_anchors_block.classList.add('d-lg-flex');
            }
        }
    }
}

const _scrollTo = (block, yOffset) => {
    const y = block.getBoundingClientRect().top + window.pageYOffset + (yOffset || 0);
    window.scrollTo({top: y, behavior: 'smooth'});
};


document.querySelectorAll('a[href*="#"]').forEach(item => item.addEventListener('click', e => {
    if (item.pathname !== '/certificates.html') {
        e.preventDefault();
        const block = document.querySelector(item.getAttribute('href'));
        if (block) {
            _scrollTo(block, -document.querySelector('header').scrollHeight);
            block.click();
        }
    }
}));

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.slider-document').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-document[data-category="${currentCategory}"]`);
        let navigation = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            }
        }
        new Swiper(item, {
            modules: [Navigation],
            spaceBetween: 20,
            slidesPerView: 'auto',
            navigation: navigation,
            breakpoints: {
                1250: {
                    slidesPerView: 3,
                },
                1470: {
                    slidesPerView: 4,
                }
            }
        })
    })
    document.querySelectorAll('.slider-articles').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-articles[data-category="${currentCategory}"]`);
        let navigation = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            }
        }
        new Swiper(item, {
            modules: [Navigation],
            spaceBetween: 20,
            slidesPerView: 'auto',
            navigation: navigation,
            breakpoints: {
                1250: {
                    slidesPerView: 3,
                },
                1470: {
                    slidesPerView: 4,
                }
            }
        })
    })
    document.querySelectorAll('.slider-reviews').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-reviews[data-category="${currentCategory}"]`);
        let navigation = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            }
        }
        new Swiper(item, {
            modules: [Navigation],
            spaceBetween: 10,
            slidesPerView: 'auto',
            navigation: navigation,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                1250: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                }
            }
        });
    });
    document.querySelectorAll('.slider-5').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-5[data-category="${currentCategory}"]`);
        let navigation = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            }
        }
        new Swiper(item, {
            modules: [Navigation],
            spaceBetween: 10,
            slidesPerView: 'auto',
            navigation: navigation,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                1250: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                1470: {
                    spaceBetween: 20,
                    slidesPerView: 4,
                },
                1645: {
                    spaceBetween: 20,
                    slidesPerView: 5,
                }
            }
        });

    });
    document.querySelectorAll('.slider-product').forEach(productSlider => {
        let next = document.querySelector('.slider-navigation-product .slider-next');
        let prev = document.querySelector('.slider-navigation-product .slider-prev');
        let navigation = {};
        navigation = {
            nextEl: next,
            prevEl: prev,
        }
        let thumbBreakPoints = {};
        if(document.querySelector('.slider-product__thumbs')){
            let thumbsBlock = document.querySelector('.slider-product__thumbs');
            if(thumbsBlock.classList.contains('no-video')){
                thumbBreakPoints = {
                    576: {
                        slidesPerView: 4,
                    },
                    1250: {
                        slidesPerView: 3,
                    },
                    1470: {
                        slidesPerView: 4,
                    }
                }
            } else {
                thumbBreakPoints = {
                    576: {
                        slidesPerView: 3,
                    },
                    1250: {
                        slidesPerView: 2,
                    },
                    1470: {
                        slidesPerView: 3,
                    }
                }
            }
        }
        let swiperProductThumbs = new Swiper('.slider-product__thumbs', {
            slidesPerView: 2,
            spaceBetween: 10,
            direction: 'horizontal',
            watchSlidesProgress: true,
            breakpoints: thumbBreakPoints,
        });
        const swiperDefOpt = {
            modules: [Navigation],
            navigation: navigation,
            spaceBetween: 10,
            slidesPerView: 1,
            breakpoints: {
                992: {
                    slidesPerView: 1,
                },
            }
        }
        const swiperProductOpt = {
            modules: [Thumbs, Navigation],
            thumbs: {
                swiper: swiperProductThumbs
            },
        }
        if(document.querySelector('.slider-product__thumbs')){
            new Swiper(productSlider, Object.assign({}, swiperDefOpt, swiperProductOpt));
        }
        else{
            new Swiper(productSlider, Object.assign({}, swiperDefOpt));
        }
    })
});

let tabs = null;
if (document.querySelector(".documents-tabs, .articles-tabs, .category-tabs")) {
    let tabsData = async () => await import('./Components/tabs');
    tabsData().then(e => tabs = e.init).then(() => tabs(".documents-tabs, .articles-tabs, .category-tabs"));
}


let _round = Math.round;
Math.round = function (number, decimals /* optional, default 0 */) {
    if (arguments.length === 1) {
        return _round(number);
    }
    let multiplier = Math.pow(10, decimals);
    return _round(number * multiplier) / multiplier;
};

document.querySelectorAll('.js-choice').forEach(choice => {
    new Choices(choice, {
        itemSelectText: '',
        position: 'bottom',
        searchEnabled: false,
    });
})


import StarRating from 'star-rating.js';
import Agent from "./Components/Core/agent";
import {notice} from "./Components/UI/notice";

if (document.querySelector('.rating')) {
    document.querySelectorAll('.star-rating').forEach(item => {
        new StarRating(item, {
            clearable: true,
            tooltip: false,
            maxStars: 5,
        })
    });
}


if (document.querySelector('.category-show')) {
    let block = document.querySelector('.category-show');
    let btns = document.querySelectorAll('.btn-show');
    let items = block.querySelectorAll('.product-item');
    btns.forEach(item => {
        item.addEventListener('click', () => {
            btns.forEach(item => item.classList.remove('active'));
            item.classList.add('active');
            if (item.classList.contains('inline-show')) {
                block.classList.remove('grid-block');
                block.classList.add('inline-block');
                items.forEach(item => item.classList.add('inline-block'));
            } else {
                block.classList.add('grid-block');
                block.classList.remove('inline-block');
                items.forEach(item => item.classList.remove('inline-block'));
            }
        });
        if (item.classList.contains('grid-show')) {
            item.classList.add('active');
        }
    });
}

document.querySelectorAll('.spoiler').forEach(item => {
    let btn = item.querySelector('.spoiler-btn');
    let container = item.querySelector('.spoiler-block');
    if (container.classList.contains('active')) {
        container.style.height = 'auto';
        // container.style.height = container.clientHeight + 'px';
    }
    btn.addEventListener('click', function (event) {
        event.preventDefault();
        btn.classList.toggle('active');
        event.target.closest('.spoiler').classList.toggle('active');
        if (!container.classList.contains('active')) {
            container.classList.add('active');
            container.style.height = 'auto';
            let height = container.clientHeight + 'px';
            container.style.height = '0px';
            setTimeout(function () {
                container.style.height = height;
            }, 0);
        } else {
            container.style.height = container.clientHeight + 'px'
            setTimeout(function () {
                container.style.height = '0px';
            }, 0);
            // container.style.height = '0px';
            setTimeout(function () {
                container.classList.remove('active');
            }, 350);
        }
    })
});
